module.exports = __webpack_public_path__ + "img/3c73138.webp";